export const LIST_QUESTIONS = "LIST_QUESTIONS";
export const ERROR_QUESTION = "ERROR_QUESTION";
export const LOADING = "LOADING";
